export const environment = {
  production: true,
  frontEndUrl: 'https://staging.zevaglobal.com',
  bhrFrontEndUrl: 'https://batteryhealth-staging.zevaglobal.com',
  apiUrl: 'https://api-staging.zevaglobal.com/',
  adminUrl: 'http://localhost:4201/',
  debug: false,
  name: 'staging',

  // Live Microservice
  liveMicroserviceUrl: 'wss://kzphsr64qb.execute-api.ca-central-1.amazonaws.com/stage/',

  // Square
  squareApplicationId: 'sandbox-sq0idb-yrZQHzXykJa3AvQujDs_Sw',
  squareLocationId: 'LK190QNJVZ009',

  // Stripe
  stripeApplicationId:
    // eslint-disable-next-line max-len
    'pk_test_51Ovfxq09v7yNXw2TbRxdQfVhVDtbLhpqE5nxt6Azy3qzSdCnMJMFiD4VwtfiLJArxXyYtCsjLyemC2bitjnMdA8200LhtJnMwc',
};
